import React, { useCallback, useEffect, useMemo, useState } from "react";
import toastr from "toastr";
import { connect } from "react-redux";
import { Row, Col, Accordion, Card } from "react-bootstrap";
import { MdKeyboardArrowRight } from "react-icons/md";

import MultiSelectWithCheckbox from "app/Components/SearchableSelect/MultiSelectCkeckOption";
import IncidentDetailsInfo from "app/_pages/_healthSafetyEnvironment/IncidentManagement/Investigator/IncidentDetailsInfo";
import ReviewerDetailsInfo from "app/_pages/_healthSafetyEnvironment/IncidentManagement/Reviewer/ReviewerDetailsInfo";
import CustomDateTime from "app/Components/DateTimeCustom/CustomDateTime";

import IncidentTimeline from "./IncidentTimeline";
import {
  getIncidentReportById,
  updateIncidentReview,
} from "app/_services/ehs/ehsIncidentServices";
import { UserService } from "app/_services/UserService/UserService";
import { Validation } from "app/_helpers/validation/Validation";
import {
  initialForm,
  severities,
  incidentReviewRules,
  commentTypes,
  evidenceCategories,
  incidentStatuses,
  initialCapa,
  capaRules,
  FORM_LABEL_OFFICER,
  STAFFEMPLOYER,
  capaStatuses,
  INVESTIGATION_STATUS,
} from "./CONSTANTS";
import { CommmonService } from "app/_services/CommonService/CommonService";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import Decline from "./DeclinePopup";
import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";
import FormSelect from "app/Components/_form/FormSelect/FormSelect";
import {
  isUserMM,
  isUserSO,
  getBackButtonText,
  getSubmitButtonText,
  checkForRevertBackButton,
} from "./Helper";
//import Capasview from "../CapasView"
import { approveRejectCapa } from "app/_services/ehs/ehsCapaServices";
import IncidentCapaTab from "./Component/ReportForm/IncidentCapaTab";
import { getAllAreaOfOperation } from "app/_services/ehs/ehsAreaOfOperationServices";
import { getCapaOwner } from "../../../_services/ehs/ehsCapaOwner";
import { getDepartment } from "app/_services/UserManagement/DepartmentService";
import ViewComments from "./ViewComments";
import moment from "moment";
import { DDMMYYYYFormat, YYYYMMDDFormat } from "app/_helpers/dateHelper";
import MMInvestigationForm from "./Component/ReviewForm/MMInvestigationForm";
import YesOrNo from "../YesOrNo.component";
import {
  contractorDropdownLabel,
  employeeDropdownLabel,
  userDropdownLabel,
} from "app/_helpers/helper";
import { getContractor } from "app/_services/Contractor/ContractorService";

const IncidentReviewForm = ({
  match: {
    params: { id: incidentDetailsId, siteId },
  },
  history,
  user,
}) => {
  const [form, setForm] = useState({
    ...initialForm,
    reviewCompletionDate: DDMMYYYYFormat(),
  });
  const [errorForm, setErrorForm] = useState({ ...initialForm });
  const [tab, setTab] = useState(+CommmonService.getQueryParam("tab") || 1);
  const [evidences, setEvidences] = useState([]);
  const [currentReportLabel, setcurrentReportLabel] = useState("");
  const [users, setUsers] = useState([]);

  const [capasErrors, setCapasErrors] = useState([]);
  const [capas, setCapas] = useState([]);
  const [area, setArea] = useState([]);
  const [subArea, setSubArea] = useState([]);
  const [capaOwners, setCapaOwners] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [mmRequestInvestigation, setMMRequestInvestigation] = useState(false);
  const [contractors, setContractors] = useState([]);

  useEffect(() => {
    getContractor().then((response) => {
      if (!response?.data) return;

      setContractors(response.data);
    });
  }, []);

  const onChange = useCallback(({ target: { name, type, value, checked } }) => {
    let extraToUpdate = {};
    if (name === "isInvestigation" && !checked) {
      extraToUpdate.investigationLeader = "";
      extraToUpdate.investigationMember = "";
      extraToUpdate.targetCompletionDate = "";
    } else {
      extraToUpdate.capas = [];
    }

    setForm((prevForm) => ({
      ...prevForm,
      [name]: type === "checkbox" ? checked : value,
      ...extraToUpdate,
    }));
  }, []);

  const [submitted, setSubmitted] = useState(false);
  const onSubmit = useCallback(
    async (e, obj) => {
      if (submitted) return;
      let flag = 0;
      if (!obj) {
        const errorObj = Validation(form, incidentReviewRules);

        if (!form.reviewCompleted)
          errorObj.reviewCompleted = "Please check this checkbox.";
        if (form.reviewEvidencesRequired && !evidences.filter((d) => !d.deleted).length)
          errorObj.reviewEvidencesRequired = "Minimum one row is required.";
        if (form.isInvestigation === true && !form.investigationLeader)
          errorObj.investigationLeader = "Please Check Investigation Leader.";

        const capaErrorArray = capas.map((data) =>
          data.deleted
            ? {}
            : Validation(
                data,
                capaRules?.map((d) =>
                  d?.field_name === "otherSubArea"
                    ? data?.subAreaId === 999
                      ? { ...d, isRequired: true }
                      : { ...d, isRequired: false }
                    : d
                )
              )
        );

        setCapasErrors(capaErrorArray);
        setErrorForm(errorObj);

        for (const key in errorObj)
          if (errorObj[key]) {
            flag = 1;
            break;
          }

        for (const array of [capaErrorArray])
          for (const errObj of array)
            for (const key in errObj)
              if (errObj[key]) {
                flag = 1;
                break;
              }

        if (flag !== 0) return toastr.warning("Please complete all forms!");
      }

      const formData = {
        // evidences,
        // severityPostReview: form.severityPostReview,
        // reviewCompleted: form.reviewCompleted,
        // reviewCompletionDate: form.reviewCompletionDate,
        reviewCompletionSummary: form.reviewCompletionSummary,
        // reviewEvidencesRequired: form.reviewEvidencesRequired,
        // investigationLeader: form.investigationLeader,
        // isInvestigation: form.isInvestigation,
        // investigationRemark: form.investigationRemark,
        capas: capas,
        // so_recommended_investigation: form.so_recommended_investigation ? 1 : 0,
        // investigationMember: form.investigationMember,
        // targetCompletionDate: form.targetCompletionDate,
      };

      if (
        form?.reportAtLabel === "so" &&
        incidentStatuses.open === form?.incidentStatus
      ) {
        // formData.reviewCompleted = form?.reviewCompleted;
        formData.reviewedDate = form?.reviewCompletionDate;
        formData.so_recommended_investigation = form.so_recommended_investigation ? 1 : 0;
      } else if (
        form?.reportAtLabel === "mm" &&
        incidentStatuses.mmReview === form?.incidentStatus
      ) {
        formData.isInvestigation = form.isInvestigation;
        formData.reviewedByMMDate = form?.reviewCompletionDate;
        formData.investigationLeader = form.investigationLeader;
        formData.investigationMember = form.investigationMember;
        formData.targetCompletionDate = form.targetCompletionDate;
      } else if (
        form?.reportAtLabel === "so" &&
        incidentStatuses.investigationCompleted === form?.incidentStatus
      ) {
        formData.reviewCompleted = form?.reviewCompleted;
        formData.investigationReviewedDate = form?.reviewCompletionDate;
      } else if (
        form?.reportAtLabel === "mm" &&
        incidentStatuses.investigationReviewed === form?.incidentStatus
      ) {
        formData.investigationReviewedByMMDate = form?.reviewCompletionDate;
        formData.severityPostReview = form.severityPostReview;
      } else if (
        form?.reportAtLabel === "so" &&
        incidentStatuses.capaCompleted === form?.incidentStatus
      ) {
        formData.finalReviewedByDate = form?.reviewCompletionDate;
      } else if (
        form?.reportAtLabel === "mm" &&
        incidentStatuses.capaReviewed === form?.incidentStatus
      ) {
        formData.closureCompletionDate = form?.reviewCompletionDate;
      }

      if (obj) {
        formData.isBack = 1;
        formData.comment = obj.comment;
      }
      setSubmitted(true);
      // console.log("/*/*/**/submitted", "submitted", submitted);
      // return;
      const response = await updateIncidentReview(formData, incidentDetailsId);
      if (!response?.status) {
        setSubmitted(false);

        return toastr.error(response?.message);
      }

      toastr.success(response?.message || "Success!");
      history.push("/health-safety-and-environment/incident-management");
    },
    [capas, evidences, form, history, incidentDetailsId, submitted]
  );

  const setFormDataById = useCallback(() => {
    if (!incidentDetailsId) return false;

    getIncidentReportById(incidentDetailsId, "role=so").then((response) => {
      if (!response?.status) {
        history.push("/health-safety-and-environment/incident-management");
        toastr.error(response?.message || "Something went Wrong");
        return;
      }
      if (!response?.data) return;

      setForm({
        ...response.data,
        reviewCompleted: "",
        reviewCompletionDate: YYYYMMDDFormat(),
      });
      setEvidences(
        response.data.evidences?.filter((data) => data.category === "Review") || []
      );
      setcurrentReportLabel(response.data.reportAtLabel.toUpperCase());
      setCapas(
        response.data.capas?.map((obj) => ({
          ...obj,
          otherSubArea: obj?.otherSubArea || "",
        }))
      );
    });
  }, [incidentDetailsId]);

  const approveCapa = useCallback(
    (index, capaId, obj) => {
      // Call API
      let payload = {};
      if (obj) {
        payload = {
          isApproved: obj?.isApproved,
          remark: obj.comment,
        };
      }
      approveRejectCapa(capaId, payload).then((response) => {
        if (obj?.isApproved) {
          !response?.status
            ? toastr.error(response?.message)
            : toastr.success("CAPA Approved!");
        } else {
          toastr.error(!response?.status ? response?.message : "CAPA Rejected!");
        }
        setFormDataById();
      });
    },
    [setFormDataById]
  );

  const addCapa = useCallback(() => {
    // if (!form?.areaId) return toastr.info("Please Select Area  First");

    // const ownerId = capaOwners.find((data) => form?.areaId === data.areaOfOperationId)?.userId;

    // if (!ownerId) return toastr.info("Owner Id  Required");

    setCapas((previous) => [
      ...previous,
      {
        ...initialCapa,
        // areaId: form.areaId,
        // subAreaId: form.subAreaId,
        siteId: form.siteId || "",
        workArea: form.workArea?.name || "",
        // ownerId: ownerId,
        incidentDetailsId,
        source: "Incident Management",
      },
    ]);
  }, [form.siteId, form.workArea?.name, incidentDetailsId]);

  const deleteCapa = useCallback(
    (index) =>
      setCapas((previous) =>
        previous
          .map((data, idx) =>
            idx !== index ? data : data.id ? { ...data, deleted: 1 } : null
          )
          .filter((data) => !!data)
      ),
    []
  );
  const onChangeCapa = useCallback(
    ({ name, value, type, checked, index }) => {
      setCapas((prevCapas) =>
        prevCapas.map((data, idx) => {
          if (idx !== index) return data;
          if (name === "areaId") {
            data["ownerId"] =
              capaOwners?.find((d) => value === d?.areaOfOperationId)?.userId || null;
            data["subAreaId"] = "";
          }

          data[name] = type === "checkbox" ? checked : value;
          return data;
        })
      );
    },
    [capaOwners]
  );

  /******* useEffect *****/
  useEffect(() => {
    if (+tab > 0) CommmonService.updateQueryParam("tab", tab);
  }, [tab]);

  useEffect(() => {
    if (form.isInvestigation) {
      setMMRequestInvestigation(true);
    } else {
      setMMRequestInvestigation(false);
    }
  }, [form.isInvestigation]);

  useEffect(() => {
    getIncidentReportById(incidentDetailsId, "role=so").then((response) => {
      if (!response?.data) return;

      let extraToUpdate = {};
      if (response?.data?.incidentStatus === incidentStatuses.mmReview)
        extraToUpdate.isInvestigation = true;

      setForm((prev) => {
        if (response.data.site?.siteType === 3) {
          prev.roName = response?.data?.site?.parentSite?.name;
          prev.roSiteId = response?.data?.site?.parentSite?.siteId;
        } else if (response?.data?.site?.siteType === 2) {
          prev.roName = response?.data?.site?.name;
          prev.roSiteId = response?.data?.site?.siteId;
        } else {
          prev.roName = "";
          prev.roSiteId = "";
        }

        return {
          ...prev,
          ...response.data,
          reviewCompleted: "",
          reviewCompletionDate: YYYYMMDDFormat(),
          ...extraToUpdate,
          locationSiteId: response.data.site?.siteId,
          rootCauseAnalysisRequired: response.data.investigationDetails
            ?.rootCauseAnalysisRequired
            ? true
            : false,
        };
      });

      // setForm({
      //   ...response.data,
      //   reviewCompleted: "",
      //   reviewCompletionDate: YYYYMMDDFormat(),
      //   ...extraToUpdate,
      // });
      setEvidences(
        response.data.evidences?.filter((data) => data.category === "Review") || []
      );
      setcurrentReportLabel(response.data.reportAtLabel.toUpperCase());
      setCapas(
        response.data.capas?.map((obj) => ({
          ...obj,
          otherSubArea: obj?.otherSubArea || "",
        }))
      );
    });

    UserService.getUsers("filter[status]=1").then((response) => {
      if (!response?.data) return;

      setUsers(response.data);
    });

    getAllAreaOfOperation().then((response) => {
      if (!response?.data) return;
      setArea(response.data);
    });

    getDepartment("filter[status]=1").then((response) => {
      if (!response?.data) return;
      setDepartments(response.data.departments);
    });

    getCapaOwner().then((response) => {
      if (!response?.data) return;
      setCapaOwners(response.data.capaOwners);
    });
  }, [incidentDetailsId]);

  /*********** useMemo *********/
  const FORM_LEVEL_SO = useMemo(
    () => form?.reportAtLabel === "so",
    [form?.reportAtLabel]
  );

  const FORM_LEVEL_MM = useMemo(
    () => form?.reportAtLabel === "mm",
    [form?.reportAtLabel]
  );

  const sentBackFlag = useMemo(() => {
    let flag = false;
    if (
      Array.isArray(capas) &&
      FORM_LEVEL_SO &&
      form?.incidentStatus === incidentStatuses.capaCompleted
    ) {
      if (capas?.find((d) => d.capaStatus === capaStatuses.open)) {
        flag = true;
      }
    }

    if (
      Array.isArray(capas) &&
      FORM_LEVEL_MM &&
      capas.length &&
      form?.incidentStatus === incidentStatuses.capaReviewed
    ) {
      if (capas?.find((d) => !d?.isApprovedBySO)) {
        flag = true;
      }
    }

    return flag;
  }, [FORM_LEVEL_MM, FORM_LEVEL_SO, capas, form?.incidentStatus]);

  return (
    <>
      <div className="healthSafetyEnvironmentWrapper">
        <div className="healthSafetyEnvironmentWrapper incidentMenu">
          <div className="hseMenuLinks card">
            <a
              onClick={() => setTab(1)}
              className={`pointer${tab === 1 ? " active" : ""}`}
              href
            >
              Timeline
            </a>

            {/* {((!(
              form?.reportAtLabel === "so" &&
              [severities[4], severities[5]].includes(form?.severity) &&
              isUserSO()
            ) &&
              !form?.isInvestigation &&
              isUserMM() &&
              form?.severity > 3 &&
              form?.incidentStatus === incidentStatuses.mmReview) ||
              form?.incidentStatus === incidentStatuses.capaCompleted ||
              form?.incidentStatus === incidentStatuses.investigationReviewed ||
              form?.incidentStatus === incidentStatuses.capaReviewed ||
              (form?.reportAtLabel === "so" && form?.severity < 4 && isUserSO())) && (
              <a
                onClick={() => setTab(2)}
                className={`pointer${tab === 2 ? " active" : ""}`}
                href
              >
                CAPA
              </a>
            )} */}

            {!(
              FORM_LEVEL_SO &&
              [severities[4], severities[5]].includes(form?.severity) &&
              form?.isCapaCompleted === 0
            ) &&
              !(
                FORM_LEVEL_MM &&
                form?.isInvestigation &&
                form?.incidentStatus === incidentStatuses.mmReview
              ) && (
                <a
                  onClick={() => setTab(2)}
                  className={`pointer${tab === 2 ? " active" : ""}`}
                  href
                >
                  CAPA
                </a>
              )}
            <a
              onClick={() => setTab(3)}
              className={`pointer${tab === 3 ? " active" : ""}`}
              href
            >
              Workflow Inputs
            </a>
          </div>
        </div>
      </div>
      <Row>
        <Col lg={9}>
          {tab === 1 && (
            <IncidentTimeline
              reportDate={form.reportDate}
              reporter={form.reporter}
              investigationCompletionDate={form.investigationCompletionDate}
              reviewCompletionDate={form.reviewCompletionDate}
              investigationDetails={form?.investigationDetails}
              reviewer={form.reviewer}
              closer={form.closer}
              personalDetails={form.personalDetails}
              vehicleDetails={form.vehicleDetails}
              assetDetails={form.assetDetails}
              spills={form.spills}
              evidences={evidences}
              investigationCompleted={
                form.investigationDetails
                  ? form.investigationDetails.investigationCompleted
                  : ""
              }
              reviewCompleted={form.reviewCompleted}
              closureCompleted={form.closureCompleted}
              isAssetIncident={form.isAssetIncident}
              isPersonalInjury={form.isPersonalInjury}
              isSpillsIncident={form.isSpillsIncident}
              isVehicleIncident={form.isVehicleIncident}
              closureCompletionDate={form.closureCompletionDate}
              incidentStatus={form.incidentStatus}
              insuranceApplicable={form.insuranceApplicable}
              complianceRequired={form.complianceRequired}
              trainingRequired={form.trainingRequired}
              witnessStatementRequired={form.witnessStatementRequired}
              rootCauseAnalysisRequired={form.rootCauseAnalysisRequired}
              solutionRequired={form.solutionRequired}
              capaRequired={form.capaRequired}
              reportEvidencesRequired={form.reportEvidencesRequired}
              evidencesRequired={form.evidencesRequired}
              reviewEvidencesRequired={form.reviewEvidencesRequired}
              incidentId={form.incidentId}
              incidentDate={form.incidentDate}
              type={form.type}
              severity={form.severity}
              severityPostReview={form.severityPostReview}
              area={form.area}
              site={form.site}
              department={form.department}
              isCapaPresent={form?.capas?.length}
              targetCompletionDate={form.targetCompletionDate}
              capaCompletionDate={form?.capaCompletionDate}
              capaCompletedByData={form?.capaCompletedByData}
              finalReviewedByDate={form?.finalReviewedByDate}
              finalReviewedByData={form?.finalReviewedByData}
              reviewedByMMDate={form?.reviewedByMMDate}
              reviewedByMMData={form?.reviewedByMMData}
              reviewedDate={form?.reviewedDate}
              staffData={form?.staffData}
              staffType={form?.staffType}
              otherStaffName={form?.otherStaffName}
              capasList={form?.capas}
              reportAtLabel={FORM_LABEL_OFFICER[form?.reportAtLabel]}
              form={form}
            />
          )}

          {tab === 2 && (
            <div className="card p-3 pb-0 mt-4">
              <div className="simple-card-title">
                <h3 class="text-capitalize mb-0">CAPA</h3>
              </div>
              <div className="ehsFormWrapper">
                <div className="w-100">
                  {/* <IncidentCapaTab approveRejectView approveCapa={approveCapa} capas={form.capas}/> */}
                  <IncidentCapaTab
                    form={form}
                    onChange={onChange}
                    error={errorForm}
                    setTab={setTab}
                    onSubmit={onSubmit}
                    capas={capas}
                    capasErrors={capasErrors}
                    onChangeCapa={onChangeCapa}
                    addCapa={addCapa}
                    deleteCapa={deleteCapa}
                    area={area}
                    capaowner={capaOwners}
                    departments={departments}
                    users={users}
                    noButton={true}
                    viewOnly={
                      (!(
                        form?.incidentStatus === incidentStatuses.investigationReviewed
                      ) &&
                        form?.capas?.length) ||
                      form?.incidentStatus === incidentStatuses.capaCompleted ||
                      form?.incidentStatus === incidentStatuses.capaReviewed
                        ? true
                        : false
                    }
                    approveCapa={approveCapa}
                    approverLevel={form?.reportAtLabel}
                    hideTitle
                    isValidDate={(day) =>
                      day.isSameOrAfter(YYYYMMDDFormat(form?.incidentDate))
                    }
                    // showReject
                    siteId={form?.siteId}
                  />
                </div>
              </div>
              <div className="stepperFormButtons">
                <span className="btn btn-left" onClick={() => setTab((prev) => prev - 1)}>
                  Back
                </span>

                {sentBackFlag && (
                  <span
                    className="pointer btn btn-right"
                    onClick={() => onSubmit(false, { isBack: 1 })}
                  >
                    {FORM_LEVEL_SO
                      ? "Send back to Area Owner"
                      : "Send back to Safety Officer"}
                  </span>
                )}
                <span
                  className="pointer btn btn-right"
                  onClick={() => {
                    setTab((prev) => prev + 1);
                  }}
                >
                  Next
                  <BsArrowRight />
                </span>
              </div>
            </div>
          )}

          {tab === 3 && (
            <div className="card p-3 pb-0 mt-4">
              <div className="simple-card-title mb-0">
                <h3 className="text-capitalize mb-0">Review</h3>
              </div>
              {/* {form.isBack === 1 && (
                <p style={{ color: "red" }}>
                  {form?.backData?.length > 0 &&
                    form?.backData[form.backData.length - 1]?.comment}
                </p>
              )} */}
              <div className="">
                <Row>
                  <Col lg={9} className="pt-2 worlflowInputComments">
                    <ViewComments
                      comments={form.incidentReviewsData ? form.incidentReviewsData : []}
                      hideTitle
                    />
                  </Col>
                  <Col lg={3} className="mt-4 pl-0">
                    <Row>
                      <Col lg={12} style={{ marginTop: "-10px" }}>
                        <div className="form-group mb-3">
                          <label>Reviewed By</label>
                          <input
                            value={user ? `${user.firstName} ${user.lastName}` : ""}
                            type="text"
                            class="form-control"
                            placeholder=""
                            readOnly
                          />
                        </div>
                      </Col>
                      <Col lg={12}>
                        <div className="form-group mb-3">
                          <label>Review Date</label>
                          <CustomDateTime
                            isValidDate={(day) => day.isBefore(moment())}
                            name="reviewCompletionDate"
                            value={form.reviewCompletionDate}
                            // isValidDate={(day) =>
                            //   day.isAfter(new Date(form.investigationCompletionDate)) &&
                            //   day.isBefore(new Date())
                            // }
                            onChange={(moment, name) =>
                              onChange({
                                target: {
                                  name,
                                  value: moment.format("YYYY-MM-DD"),
                                },
                              })
                            }
                            readOnly
                          />
                          <span className="small text-danger">
                            {errorForm.reviewCompletionDate}
                          </span>
                        </div>
                      </Col>
                      <Col lg={12}>
                        <div className="form-group mb-3">
                          <label>Severity Type (Reported)</label>

                          <SimpleSelect
                            name="severity"
                            value={form.severity}
                            className="form-control"
                            disabled
                            options={Object.keys(severities)}
                            object={severities}
                          ></SimpleSelect>
                        </div>
                      </Col>
                      {form?.investigationId &&
                        form?.incidentStatus ===
                          incidentStatuses.investigationReviewed && (
                          <Col lg={12}>
                            <div className="form-group mb-3">
                              <label>Severity Type (Post Review)</label>

                              <SimpleSelect
                                name="severityPostReview"
                                value={form.severityPostReview}
                                onChange={onChange}
                                className="form-control"
                                options={Object.keys(severities)}
                                object={severities}
                              ></SimpleSelect>

                              <span className="small text-danger">
                                {errorForm.severityPostReview}
                              </span>
                            </div>
                          </Col>
                        )}
                      <Col lg={12} className="my-3">
                        <div className="form-group mb-2">
                          <label>
                            {FORM_LABEL_OFFICER[form?.reportAtLabel]} Review Inputs
                          </label>
                          <textarea
                            class="form-control"
                            style={{ height: 130 }}
                            name="reviewCompletionSummary"
                            value={form.reviewCompletionSummary}
                            onChange={onChange}
                            maxLength={500}
                            placeholder="Max 500 Characters"
                          />
                          <span className="small text-danger">
                            {errorForm.reviewCompletionSummary}
                          </span>
                        </div>
                      </Col>
                      <Col lg={12}>
                        <label className="checkbox checkbox-primary">
                          <input
                            type="checkbox"
                            checked={form.reviewCompleted}
                            name="reviewCompleted"
                            onChange={onChange}
                          />
                          <span>Review Completed</span>
                          <span className="checkmark" />
                        </label>
                        <span className="small text-danger">
                          {errorForm.reviewCompleted}
                        </span>
                      </Col>
                      {form?.reportAtLabel === "so" &&
                        isUserSO() &&
                        form.severity > 3 &&
                        form?.incidentStatus !== incidentStatuses.capaReviewed &&
                        form?.incidentStatus !== incidentStatuses.capaCompleted &&
                        form?.investigationDetails?.investigationStatus !==
                          INVESTIGATION_STATUS.completed && (
                          <Col lg={12}>
                            <label className="checkbox checkbox-primary">
                              <input
                                type="checkbox"
                                checked={form.so_recommended_investigation}
                                name="so_recommended_investigation"
                                onChange={onChange}
                              />
                              <span>Investigation Recommended</span>
                              <span className="checkmark" />
                            </label>
                            <span className="small text-danger">
                              {errorForm.so_recommended_investigation}
                            </span>
                          </Col>
                        )}
                    </Row>
                  </Col>
                </Row>
                {isUserMM() &&
                  FORM_LEVEL_MM &&
                  form?.severity > 3 &&
                  form?.incidentStatus !== incidentStatuses.open &&
                  form?.incidentStatus !== incidentStatuses.capaCompleted &&
                  form?.incidentStatus !== incidentStatuses.capaReviewed &&
                  form?.investigationDetails?.investigationStatus !==
                    INVESTIGATION_STATUS.completed && (
                    <div>
                      <div className="mb-3 mt-3">
                        <YesOrNo
                          title="Do you want to request investigation."
                          name="isInvestigation"
                          value={form.isInvestigation}
                          onChange={onChange}
                          acceptTitle="YES"
                          rejectTitle="NO"
                        />
                        <span className="small text-danger">
                          {errorForm.isInvestigation}
                        </span>
                      </div>
                      {form.isInvestigation && (
                        <MMInvestigationForm
                          form={form}
                          onChange={onChange}
                          setForm={setForm}
                          errorForm={errorForm}
                          users={users}
                        />
                      )}
                    </div>
                  )}

                <div className="stepperFormButtons">
                  <span
                    className="pointer btn btn-left"
                    onClick={() => setTab((prev) => prev - 1)}
                  >
                    <BsArrowLeft /> Back
                  </span>

                  {sentBackFlag && (
                    <span
                      className="pointer btn btn-right"
                      onClick={() => onSubmit(false, { isBack: 1 })}
                    >
                      {FORM_LEVEL_SO
                        ? "Send back to Area Owner"
                        : "Send back to Safety Officer"}
                    </span>
                  )}

                  {!sentBackFlag && (
                    <>
                      {checkForRevertBackButton(form) && (
                        <Decline
                          id={incidentDetailsId}
                          onSubmit={(obj) => onSubmit(null, obj)}
                          name={getBackButtonText(form)}
                        />
                      )}

                      <span className="pointer btn btn-right" onClick={() => onSubmit()}>
                        {getSubmitButtonText(mmRequestInvestigation, form)}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
          <div className="mt-4 text-center">
            <span className="btn btn-secondary mx-2" onClick={history.goBack}>
              Go Back to Main Menu
            </span>
          </div>
        </Col>
        <Col lg={3}>
          <div className="mt-4">
            <h5>You are editing as a {FORM_LABEL_OFFICER[form?.reportAtLabel]}.</h5>
            <Accordion>
              <div className="mb-3">
                <Accordion.Toggle
                  as={Card.Header}
                  eventKey="10"
                  className="rightIncidentCard p-0"
                >
                  <div className="rightInfoTitle">
                    {/* <MdEdit
                                            onClick={() => history.push((siteId ? `/sites/${siteId}` : "") + `/health-safety-and-environment/incident-management/report/edit/${incidentDetailsId}`)}
                                        /> */}
                    Reporter
                    <MdKeyboardArrowRight />
                  </div>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="10">
                  <Card.Body className="p-0">
                    <IncidentDetailsInfo
                      state={form.state}
                      longDurationFire={form.longDurationFire}
                      lostManhoursEmployees={form.lostManhoursEmployees}
                      lostManhoursContractors={form.lostManhoursContractors}
                      lostManhoursOthers={form.lostManhoursOthers}
                      department={form.department}
                      description={form.description}
                      equipmentFailure={form.equipmentFailure}
                      fallOfObject={form.fallOfObject}
                      inundation={form.inundation}
                      explosion={form.explosion}
                      facilityOutage={form.facilityOutage}
                      facilityShutdown={form.facilityShutdown}
                      facilityStatus={form.facilityStatus}
                      fatalityEmployees={form.fatalityEmployees}
                      fatalityContractors={form.fatalityContractors}
                      fatalityOthers={form.fatalityOthers}
                      fireInvolved={form.fireInvolved}
                      functionData={form.functionData}
                      incidentDate={form.incidentDate}
                      incidentId={form.incidentId}
                      incidentStatus={form.incidentStatus}
                      indirectLosses={form.indirectLosses}
                      injuredEmployees={form.injuredEmployees}
                      injuredContractors={form.injuredContractors}
                      injuredOthers={form.injuredOthers}
                      measuresOrActions={form.measuresOrActions}
                      peopleCount={form.peopleCount}
                      permanentDisability={form.permanentDisability}
                      reportDate={form.reportDate}
                      severity={form.severity}
                      reportedBy={form.reporter}
                      similarIncidentHappened={form.similarIncidentHappened}
                      summary={form.summary}
                      site={form.site}
                      workArea={form.workArea}
                      type={form.type}
                      personalDetails={form.personalDetails}
                      assetDetails={form.assetDetails}
                      vehicleDetails={form.vehicleDetails}
                      spills={form.spills}
                      evidences={form.evidences?.filter(
                        (data) => data.category === evidenceCategories.report
                      )}
                      insuranceApplicable={form.insuranceApplicable}
                      complianceRequired={form.complianceRequired}
                      trainingRequired={form.trainingRequired}
                      witnessStatementRequired={form.witnessStatementRequired}
                      rootCauseAnalysisRequired={form.rootCauseAnalysisRequired}
                      solutionRequired={form.solutionRequired}
                      capaRequired={form.capaRequired}
                      reportEvidencesRequired={form.reportEvidencesRequired}
                      evidencesRequired={form.evidencesRequired}
                      reviewEvidencesRequired={form.reviewEvidencesRequired}
                      regionalOffice={form.site ? form.site.parentSite : ""}
                      staffType={form.staffType}
                      staffEmployer={
                        form?.staffType === "contractor"
                          ? form?.StaffNameObject?.contractors?.contractorLegalEntity
                          : STAFFEMPLOYER.find((d) => d.id === form?.staffEmployer)
                              ?.contactPerson
                      }
                      staffName={
                        form?.staffType === "employee"
                          ? `${employeeDropdownLabel(form?.staffData)}`
                          : form?.staffType === "contractor"
                          ? `${contractorDropdownLabel(form?.staffData)}`
                          : form?.otherStaffName
                      }
                      area={form.area}
                      subArea={form.subArea}
                      subAreaId={form.subAreaId}
                      otherSubArea={form.otherSubArea}
                      shift={form.shift}
                      activity={form.activity}
                      subActivity={form.subActivity}
                      capasDetails={form.capas}
                      locationSiteId={form?.locationSiteId}
                      roSiteId={form?.roSiteId}
                      contractors={contractors}
                      alcoholViolator={form.alcoholViolator}
                      ppeViolator={form.ppeViolator}
                      unfitBuyerTruck={form.unfitBuyerTruck}
                      unfitHEMM={form.unfitHEMM}
                    />
                  </Card.Body>
                </Accordion.Collapse>
              </div>
              {form.severity > 3 && form?.investigationDetails && (
                <div className="mb-3">
                  <Accordion.Toggle
                    as={Card.Header}
                    eventKey="11"
                    className="rightIncidentCard p-0"
                  >
                    <div className="rightInfoTitle">
                      Investigator <MdKeyboardArrowRight />
                    </div>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="11">
                    <Card.Body className="p-0">
                      <ReviewerDetailsInfo
                        investigationCompletionDate={
                          form?.investigationDetails?.investigationCompletionDate
                        }
                        investigationCompletionSummary={
                          form?.investigationDetails?.investigationCompletionSummary
                        }
                        severity={form?.investigationDetails?.severity}
                        insuranceApplicable={
                          form?.investigationDetails?.insuranceApplicable
                        }
                        insuranceClaimRaised={
                          form?.investigationDetails?.insuranceClaimRaised
                        }
                        insuranceClaimAmount={
                          form?.investigationDetails?.insuranceClaimAmount
                        }
                        insuranceApprovedAmount={
                          form?.investigationDetails?.insuranceApprovedAmount
                        }
                        insuranceUnapprovedAmount={
                          form?.investigationDetails?.insuranceUnapprovedAmount
                        }
                        cause={form?.investigationDetails?.cause}
                        fireCause={form?.investigationDetails?.fireCause}
                        avoidable={form?.investigationDetails?.avoidable}
                        couldAvoidBy={form?.investigationDetails?.couldAvoidBy}
                        environmentalImpact={
                          form?.investigationDetails?.environmentalImpact
                        }
                        solutionType={form?.investigationDetails?.solutionType}
                        compliances={form?.investigationDetails?.compliances}
                        trainings={form?.investigationDetails?.trainings}
                        mitigationMeasures={
                          form?.investigationDetails?.mitigationMeasures
                        }
                        witnessStatements={form?.witnessStatements}
                        rootCauseDescriptions={
                          form?.investigationDetails?.rootCauseDescriptions
                        }
                        immediateCause={form?.investigationDetails?.immediateCause}
                        indirectCause={form?.investigationDetails?.indirectCause}
                        causeIndirect={form?.causeIndirect}
                        causeImmediate={form?.causeImmediate}
                        solutions={form?.investigationDetails?.solutions}
                        capas={form.capas}
                        investigator={form?.investigationDetails?.investigator}
                        evidences={form.investigationDetails?.investigationEvidences?.filter(
                          (data) => data.category === evidenceCategories.investigation
                        )}
                        documents={form?.investigationDetails?.documents?.filter(
                          (data) =>
                            data.category === evidenceCategories.investigationOther
                        )}
                        comments={form.comments?.filter(
                          (data) => data.type === commentTypes.investigation
                        )}
                        incident={form}
                        users={users}
                        targetCompletionDate={
                          form?.investigationDetails?.targetCompletionDate
                        }
                        rootCause={form?.investigationDetails?.rootCause}
                        area={area}
                        severityPostReview={form?.severityPostReview}
                      />
                    </Card.Body>
                  </Accordion.Collapse>
                </div>
              )}
            </Accordion>
          </div>
        </Col>
      </Row>
    </>
  );
};

const mapStateToProps = (state) => ({
  user: state.user?.user,
});

export default connect(mapStateToProps)(IncidentReviewForm);
